import { EmulatorType } from '@localstack/types';

export interface SignupFormData {
  email: string;
  password: string;
}

export type FinishAccountCreationFormData = SignupFormData & {
  firstname: string;
  lastname: string;
  job_title: string;
  tos: boolean;
  newsletter: boolean;
  emulator: EmulatorType;
};

export enum PlanChoice {
  FREE = 'free',
  TRIAL = 'trial',
  /** Not offered as a radio: an emulator that only runs as a preview selects this on its own. */
  PREVIEW = 'preview',
}

export enum STEPS_ENUM {
  LOGIN_DETAILS_STEP = 1,
  LS_CHECK_EMAIL_STEP = 2,
}
